import { useEffect, useState } from 'react';

export const LG_UP_MQ = '(min-width: 1024px)';

/** True at Tailwind `lg` breakpoint and above (1024px). */
export function useIsLgUp() {
  const [isLgUp, setIsLgUp] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(LG_UP_MQ).matches : false
  );

  useEffect(() => {
    const mq = window.matchMedia(LG_UP_MQ);
    const update = () => setIsLgUp(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return isLgUp;
}
